// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberLicenseUpsearchModel {
    static getAttributeTypeMap() {
        return PrescriberLicenseUpsearchModel.attributeTypeMap;
    }
}
PrescriberLicenseUpsearchModel.discriminator = undefined;
PrescriberLicenseUpsearchModel.attributeTypeMap = [
    {
        "name": "prescriberLicenseId",
        "baseName": "prescriberLicenseId",
        "type": "number"
    },
    {
        "name": "licenseType",
        "baseName": "licenseType",
        "type": "PrescriberLicenseType"
    },
    {
        "name": "licenseNumber",
        "baseName": "licenseNumber",
        "type": "string"
    }
];
//# sourceMappingURL=prescriberLicenseUpsearchModel.js.map